window.addEventListener('DOMContentLoaded', (e) => {
    //モーダルを開くタイミングで一瞬ファーストビューが点滅のように表示されるため見えなくなったら非表示に
    const kvEl  = document.getElementById('js-arr25__kv');
    const firstSectionEl = document.getElementById('ceiling-pendant'); // data-nav-target="1"
    if (kvEl && firstSectionEl) {
        const headerEl = document.getElementById('js-awsHeader');
        const kvThreshold = headerEl ? headerEl.offsetHeight : 0;

        let kvRaf = 0;
        const kvCheck = () => {
            kvRaf = 0;
            const top = firstSectionEl.getBoundingClientRect().top;

            // headerの高さ + 100px を超えたら非表示
            if (top <= kvThreshold - 100) {
                kvEl.classList.add('is-hidden');
            } else {
                kvEl.classList.remove('is-hidden');
            }
        };

        const kvOnScroll = () => {
            if (kvRaf) return;
            kvRaf = requestAnimationFrame(kvCheck);
        };

        window.addEventListener('scroll', kvOnScroll, { passive: true });
        window.addEventListener('resize', kvCheck);
        kvCheck();
    }

    //スクロールアニメーション=================================================================================
    let ticking = false;
    // スクロールアニメーション処理
    function handleScroll() {
        // テキストアニメーション処理
        const scroll_animate_txt = document.querySelectorAll('.js-arr25-fadeTxt');
        const scroll_animate_pic = document.querySelectorAll('.js-arr25-fadePic');
        const windowHeight = window.innerHeight;

        // テキストアニメーション
        scroll_animate_txt.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('js-show');
            }
        });

        // 画像アニメーション
        scroll_animate_pic.forEach(element => {
            const elementTop = element.getBoundingClientRect().top;
            if (elementTop < windowHeight) {
                element.classList.add('js-show');
            }
        });

        ticking = false; // 処理完了後にtickingを解除
    }
    // スクロールの最適化
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }
    // スクロールイベントに対して関数を追加
    window.addEventListener('scroll', onScroll);

    //navの大きさを変更===================================================================================================
    const targetSection = document.getElementById("js-arr25-navTarget");
    const nav = document.getElementById("js-arr25__nav");
    const hideTrigger = document.getElementById("js-arr25-navHide");

    if (!targetSection || !nav || !hideTrigger) return;

    // ナビを小さくする処理
    const navObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    nav.classList.add("js-arr25__nav--small");
                } else {
                    nav.classList.remove("js-arr25__nav--small");
                }
            });
        },
        {
            threshold: 0.02
        }
    );
    navObserver.observe(targetSection);

    // ナビを非表示にする処理
    const hideObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // hideTrigger が表示範囲に入った＝その下に到達した
                    nav.classList.add("is-hidden");
                } else {
                    nav.classList.remove("is-hidden");
                }
            });
        },
        {
            root: null,
            threshold: 0, // 表示エリアに少しでも入ったら反応
        }
    );
    hideObserver.observe(hideTrigger);
    
    //nav内のsvgの色を変更================================================================================================
    (() => {
        const nav = document.getElementById('js-arr25__nav');
        if (!nav) return;

        const sections = Array.from(document.querySelectorAll('.js-arr25__sec[id]'));
        if (!sections.length) return;

        // data-id を使って高速マッピング
        const fills = new Map();
        nav.querySelectorAll('a[data-id]').forEach(a => {
            const id = a.dataset.id;
            const fill = a.querySelector('.js-arr25__nav__a__in__icn__fill');
            if (id && fill) fills.set(id, fill);
        });

        const clear = () => {
            fills.forEach(el => el.classList.remove('is-active'));
        };

        const activate = (id) => {
            const fill = fills.get(id);
            if (!fill) return;
            clear();
            fill.classList.add('is-active');
        };

        let raf = 0;
        const spy = () => {
            const probe = window.innerHeight * 0.9;
            let currentId = null;

            for (const sec of sections) {
                const rect = sec.getBoundingClientRect();
                if (rect.top <= probe && rect.bottom > probe) {
                    currentId = sec.id;
                    break;
                }
            }

            if (!currentId) {
                if (window.scrollY < sections[0].offsetTop) {
                    clear();
                    return;
                }
                currentId = sections[sections.length - 1].id;
            }

            activate(currentId);
        };

        const onScroll = () => {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(spy);
        };

        // イベント登録
        document.addEventListener('DOMContentLoaded', spy, { once: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', () => requestAnimationFrame(spy));
        window.addEventListener('hashchange', () => setTimeout(spy, 0));

        // ナビクリック時に即時反映
        nav.addEventListener('click', (e) => {
            const a = e.target.closest('a[data-id]');
            if (!a) return;
            activate(a.dataset.id);
        });
    })();

    //各セクションをstickyで固定させる場合に要素の高さを設定するjs
    // window.addEventListener('load', () => {
    //     const sections = document.querySelectorAll('.js-arr25__sec');
    //     sections.forEach(sec => {
    //         const h = sec.offsetHeight; // 要素の高さを取得
    //         sec.style.height = (h + 932) + 'px';
    //
    //         // 子要素に .js-arr25__sec__in--absolute があれば js-loaded 付与
    //         const absoluteChild = sec.querySelector('.js-arr25__sec__in--absolute');
    //         if (absoluteChild) {
    //             absoluteChild.classList.add('js-loaded');
    //         }
    //     });
    // });

    //タイミングを合わせて下から上にフェードイン================================================================================================
    const sv_covers = document.querySelectorAll(".js-arr25-syncFade");
    const sv_observer = new IntersectionObserver(
        function (sv_entries) {
            sv_entries.forEach(sv_entry => {
                const sv_cover = sv_entry.target;
                const sv_texts = sv_cover.querySelectorAll(".js-arr25-syncFade__txt");
                const sv_pics = sv_cover.querySelectorAll(".js-arr25-syncFade__pic");

                if (sv_entry.isIntersecting) {
                    sv_texts.forEach(el => el.classList.add("js-show"));
                    sv_pics.forEach(el => el.classList.add("js-show"));

                    // 一度表示したら監視解除
                    sv_observer.unobserve(sv_cover);
                }
            });
        },
        {
            threshold: 0.01
        }
    );

    sv_covers.forEach(sv_cover => sv_observer.observe(sv_cover));

    //modal内のswiper====================================================================================================
    function manageSlideClassesNextNext(swiper) {
        const activeIndex = swiper.activeIndex;
        const slides = swiper.slides;
        const totalSlides = slides.length;

        slides.forEach(slide => {
            slide.classList.remove('js-arr25__sec__item__mdl__sec__in__swp__slide--next-next');
        });

        const nextNextIndex = (activeIndex + 2) % totalSlides;
        const nextNextSlide = slides[nextNextIndex];
        if (nextNextSlide) {
            nextNextSlide.classList.add('js-arr25__sec__item__mdl__sec__in__swp__slide--next-next');
        }
    }

    function initializePagination(container, swiper) {
        const paginationCount = container.querySelector('.js-arr25__sec__item__mdl__sec__in__swp__pagination__count');
        const paginationLength = container.querySelector('.js-arr25__sec__item__mdl__sec__in__swp__pagination__count__length');
        const totalSlides = swiper.slides.length;

        if (paginationCount && paginationLength) {
            paginationCount.innerHTML = '';

            for (let i = 1; i <= totalSlides; i++) {
                const numElement = document.createElement('span');
                numElement.classList.add('arr25__sec__item__mdl__sec__in__swp__pagination__count__num');
                if (i === 1) {
                    numElement.classList.add('is-active');
                }
                numElement.textContent = i.toString().padStart(2, '0');
                paginationCount.appendChild(numElement);
            }

            paginationLength.textContent = `/${totalSlides.toString().padStart(2, '0')}`;
            paginationCount.appendChild(paginationLength);
        }
    }

    function updatePagination(container, swiper) {
        const paginationCount = container.querySelector('.arr25__sec__item__mdl__sec__in__swp__pagination__count');
        const currentSlideIndex = swiper.realIndex;

        if (paginationCount) {
            const numElements = paginationCount.querySelectorAll('.arr25__sec__item__mdl__sec__in__swp__pagination__count__num');
            numElements.forEach((el, index) => {
                if (index === currentSlideIndex) {
                    el.classList.add('is-active');
                    el.classList.remove('is-out');
                } else if (el.classList.contains('is-active')) {
                    el.classList.remove('is-active');
                    el.classList.add('is-out');
                } else {
                    el.classList.remove('is-out');
                }
            });
        }
    }

    function updateActiveButton(activeIndex, group) {
        const buttons = group.querySelectorAll('.js-arr25__sec__item__mdl__model__sec__varNav__btn');
        buttons.forEach((btn, i) => {
            btn.classList.toggle(
                'is-active',
                i === activeIndex
            );
        });
    }

    // モーダルが開いたあとに、model swiper を初期化
    function modelSwiper(modal) {
        const isMobile = window.innerWidth <= 1023; // スマホ判定

        modal.querySelectorAll('.js-arr25-parent').forEach(group => {
            const container = group.querySelector('.js-arr25__sec__item__mdl__model__sec__swp');
            if (!container) return;

            const innerContainer = container.querySelector('.js-arr25__sec__item__mdl__model__sec__swp__in');

            // 既にSwiperが初期化されているか確認
            const isInitialized = innerContainer?.classList.contains('swiper-initialized');

            if (isMobile) {
                // モバイルならSwiperを初期化または更新
                if (isInitialized) {
                    innerContainer.swiper.update?.();
                } else {
                    const swiper = new Swiper(innerContainer, {
                        loop: false,
                        speed: 800,
                        slidesPerView: 1,
                        navigation: {
                            prevEl: container.querySelector('.arr25__sec__item__mdl__model__sec__swp__prev'),
                            nextEl: container.querySelector('.arr25__sec__item__mdl__model__sec__swp__next'),
                        },
                        scrollbar: {
                            el: container.querySelector('.arr25__sec__item__mdl__model__sec__swp__scrollbar'),
                            draggable: true,
                        },
                        on: {
                            slideChange: function () {
                                updateActiveButton(swiper.realIndex, group);
                            }
                        }
                    });

                    // カラーボタンのクリック挙動
                    const buttons = group.querySelectorAll('.js-arr25__sec__item__mdl__model__sec__varNav__btn');
                    buttons.forEach((btn, i) => {
                        btn.addEventListener('click', () => {
                            swiper.slideToLoop(i);
                            updateActiveButton(i, group);
                        });
                    });

                    updateActiveButton(swiper.realIndex, group);
                }
            } else {
                // PCならSwiperが初期化されていた場合はdestroy
                if (isInitialized && innerContainer.swiper) {
                    innerContainer.swiper.destroy(true, true);
                }
            }
        });
    }

    window.addEventListener('resize', () => {
        document.querySelectorAll('.js-c-modalCnt').forEach(modal => {
            modelSwiper(modal);
        });
    });

    function relatedSwiper() {
        document.querySelectorAll('.js-arr25__sec__item__related__swp').forEach(container => {
            if (container.classList.contains('swiper-initialized')) return;

            new Swiper(container, {
                slidesPerView: 1.737,
                loop: false,
                freeMode: true,
                mousewheel: {
                    forceToAxis: true,
                    sensitivity: 3
                },
                spaceBetween: 10,
                breakpoints: {
                    768: {
                        slidesPerView: 2.5,
                    },
                    1024: {
                        slidesPerView: 5.618,
                    }
                },
            });
        });
    }

    document.querySelectorAll('.js-c-modalCnt').forEach(modal => {
        const scrollContainer = modal.querySelector('.c-modalCnt__in');
        const hiddenBlocks = modal.querySelectorAll('.js-arr25-mdl-none-block');

        if (!scrollContainer || hiddenBlocks.length === 0) return;

        // 二重登録を防止
        if (scrollContainer.dataset.arr25ArtScrollRegistered === 'true') return;
        scrollContainer.dataset.arr25ArtScrollRegistered = 'true';

        scrollContainer.addEventListener('scroll', function onScrollOnce() {
            hiddenBlocks.forEach(el => {
                el.classList.add('is-visible');
            });
            scrollContainer.removeEventListener('scroll', onScrollOnce);

            modelSwiper(modal);
            relatedSwiper(modal);

            // ✅ 複数の .js-arr25__sec__item__mdl__sec__in__swp に対して処理
            const swiperContainers = modal.querySelectorAll('.js-arr25__sec__item__mdl__sec__in__swp');
            swiperContainers.forEach(swiperContainer => {
                if (swiperContainer.classList.contains('swiper-initialized')) {
                    swiperContainer.swiper.update();
                    return;
                }

                requestAnimationFrame(() => {
                    new Swiper(swiperContainer, {
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false
                        },
                        loop: true,
                        speed: 100,
                        preventInteractionOnTransition: true,
                        slidesPerView: 1,
                        effect: "fade",
                        slideActiveClass: 'swiper-slide-active--main',
                        navigation: {
                            nextEl: swiperContainer.querySelector('.js-arr25__sec__item__mdl__sec__in__swp__pagination__next'),
                        },
                        pagination: {
                            el: swiperContainer.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        on: {
                            init: function () {
                                const bullets = swiperContainer.querySelectorAll('.swiper-pagination-bullet');
                                bullets.forEach((b, index) => b.setAttribute('data-index', index + 1));
                                initializePagination(swiperContainer, this);
                                manageSlideClassesNextNext(this);
                            },
                            slideChange: function () {
                                const bullets = swiperContainer.querySelectorAll('.swiper-pagination-bullet');
                                const activeBullet = swiperContainer.querySelector('.swiper-pagination-bullet-active');

                                if (activeBullet?.getAttribute('data-index') === "1") {
                                    bullets.forEach(b => b.classList.remove('done', 'start'));
                                } else if (activeBullet?.previousElementSibling) {
                                    activeBullet.previousElementSibling.classList.add('done');
                                }

                                if (activeBullet) {
                                    activeBullet.classList.remove('done');
                                    activeBullet.classList.add('start');
                                }

                                const firstMainSlide = swiperContainer.querySelector('.js-arr25__sec__item__mdl__sec__in__swp__slide--first');
                                if (this.realIndex === 1 && firstMainSlide) {
                                    firstMainSlide.classList.remove('js-arr25__sec__item__mdl__sec__in__swp__slide--first');
                                }

                                manageSlideClassesNextNext(this);
                                updatePagination(swiperContainer, this);
                            }
                        }
                    });
                });
            });
        });
    });

    //instagram bg======================================================================================================
    // const arr25Instagram = document.getElementById('js-arr25__instagram__pic');
    // const arr25InstagramImg = document.querySelector('.arr25__instagram__pic__img');
    // const arr25Instagram_observer = new IntersectionObserver((entries) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             arr25InstagramImg.classList.add('animate');
    //         }
    //     });
    // }, {
    //     threshold: 0.1 // 要素が10%見えたら発動
    // });
    // arr25Instagram_observer.observe(arr25Instagram);

    //カーソルアニメーション================================================================================================
    // 変数の宣言
    const cursor = document.getElementById("js-cursor");
    const cWidth = 8;
    const fWidth = 40;
    const delay = 10;
    let mouseX = 0;
    let mouseY = 0;
    let posX = 0;
    let posY = 0;
    let hasLoaded = false; // 初回実行のためのフラグ

    // TweenMaxを使ったアニメーションループ
    TweenMax.to({}, 0.001, {
        repeat: -1,
        onRepeat: function() {
            posX += (mouseX - posX) / delay;
            posY += (mouseY - posY) / delay;

            TweenMax.set(cursor, {
                css: {
                    left: mouseX - (cWidth / 2),
                    top: mouseY - (cWidth / 2)
                }
            });
        }
    });

    // マウスムーブイベント
    document.addEventListener("mousemove", function(e) {
        // マウスの位置を常に更新
        mouseX = e.clientX;
        mouseY = e.clientY;

        // 初回のマウス移動時にクラスを追加
        if (!hasLoaded) {
            cursor.classList.add("js-loaded"); // 初回でクラスを追加
            hasLoaded = true; // フラグをセットして初回以降の動作を防ぐ
        }
    });

    // "a"タグにマウスエンターとリーブのイベントを設定
    document.querySelectorAll("a").forEach(link => {
        link.addEventListener("mouseenter", function() {
            cursor.classList.add("is-link");
        });
        link.addEventListener("mouseleave", function() {
            cursor.classList.remove("is-link");
        });
    });
    // hover黒丸の要素--------------------------------------------------------------------------
    document.querySelectorAll(".js-awsHeader__pc__menu").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".awsHeader__icon__in__blk").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".js-headerSearch-close").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelectorAll(".headerSearch__modal__inner__word__tag").forEach(link => {
        link.classList.add("js-cursor-black");
    });
    document.querySelector(".search__modal__inner__form__btn").classList.add("js-cursor-black");
    //モーダルの閉じるボタンもhoverで黒丸に
    document.getElementById("js-c-modalClose").classList.add("js-cursor-black");
    document.getElementById("js-c-modalClose__cross").classList.add("js-cursor-black");

    document.querySelectorAll(".js-cursor-black").forEach(link => {
        link.addEventListener("mouseenter", function() {
            cursor.classList.add("js-cursor-black--active");
        });
        link.addEventListener("mouseleave", function() {
            cursor.classList.remove("js-cursor-black--active");
        });
    });
});